
















































































import {
  Component,
  Prop,
  PropSync,
  Watch,
  Emit,
  Vue,
} from "vue-property-decorator";

@Component({
  name: "base-modal",
})
export default class BaseModal extends Vue {
  // Shows the X to close the modal
  @PropSync("showClose", { type: Boolean, default: true })
  public syncedShowClose!: boolean;

  // Modal type (notice|mini|"")
  @PropSync("type", { type: String, default: "" })
  public syncedType!: "notice" | "mini" | "";

  // Modal dialog css classes
  @PropSync("modalClasses", { type: [Object, String] })
  public syncedModalClasses!: [object, string];

  // Modal dialog content css classes
  @PropSync("modalContentClasses", { type: [Object, String] })
  public syncedModalContentClasses!: [object, string];

  // Modal gradient type (danger, primary etc)
  @PropSync("gradient", { type: String })
  public syncedGradient!: string;

  // Modal Header css classes
  @PropSync("headerClasses", { type: [Object, String] })
  public syncedHeaderClasses!: [object, string];

  // Modal Body css classes
  @PropSync("bodyClasses", { type: [Object, String] })
  public syncedBodyClasses!: [object, string];

  // Modal Footer css classes
  @PropSync("footerClasses", { type: [Object, String] })
  public syncedFooterClasses!: [object, string];

  // Modal opened or not
  @PropSync("opened", { type: Boolean })
  public syncedOpened!: boolean;

  @Prop({ default: true })
  public showCancel!: boolean;

  @Prop({ default: "Cancel" })
  public cancelLabel!: string;

  @Prop({ default: false })
  public noCloseOnBackdrop!: boolean;

  @Emit("modal:toggle")
  public closeModal() {
    return false;
  }

  @Emit("modal:toggle")
  public openModal() {
    return true;
  }

  private closeModalBackDrop() {
    if (!this.noCloseOnBackdrop) {
      this.closeModal();
    }
  }

  @Watch("opened")
  private onOpenedChanged(val: boolean) {
    const documentClasses = document.body.classList;
    if (val) {
      documentClasses.add("modal-open");
    } else {
      documentClasses.remove("modal-open");
    }
  }
}
